// extracted by mini-css-extract-plugin
module.exports = {"loader-container":"multi-modal-loaders_loader-container__6DCx6","image-loader":"multi-modal-loaders_image-loader__v84fj","text-loader":"multi-modal-loaders_text-loader__C48QZ"};